/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
	//UilCalendarAlt,
	UilEllipsisV,
	//UilSearch,
	//UilChartDown,
	//UilBoltAlt,
	//UilTear,
	//UilBusAlt,
	//UilPhone,
	//UilTrophy,
	//UilAngleDown,
} from '@iconscout/react-unicons';
import * as S from './style';
import HeaderUserButton from '../LogOut';

import TrendingUp from '../../../../img/trending_up.svg';
import TrendingDown from '../../../../img/trending_down.svg';

//import AccountIcon from '../../../../img/account.svg';
import ArrowDownDark from '../../../../img/arrow_dropdown-dark.svg';

import DataSaverGreen from '../../../../img/data_saver_green.svg';
import DataSaverRed from '../../../../img/data_saver_red.svg';
//import PieChartGreen from '../../../../img/pie_chart-green.svg';

import MoreVertBlack from '../../../../img/more_vert-black.svg';

import api from '../../../../services/api';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import Chart from 'react-google-charts';
import useDraggableScroll from 'use-draggable-scroll';
import {
	//TransactionTotal,
	DashTransactionPayment,
	DashResumeType,
	DashPorTipo,
	TransacoesDuplicadas as TDupli,
	DashConta,
	DashConciliacao,
	DashTransacaoChargeback,
} from '../../../../model/model';
// import GoogleMapReact from 'google-map-react';
import {
	//CalendarDropdown,
	CalendarModal,
	SingleDropdownCalendar,
} from '../CalendarContainer';
//import { ModalCalendarSettings } from '../CalendarContainer/style';

export default function Dashboard() {
	/*const testMarkers = [
		{
			lat: 2.818372,
			lng: -60.6702607,
			name: 'test 1',
			size: 30,
			color: '#00C952',
		},

		{
			lat: 2.818286322416371,
			lng: -60.66890083645637,
			name: 'test 2',
			size: 40,
			color: '#00C952',
		},
		{
			lat: 2.8178228614103142,
			lng: -60.668070692820486,
			name: 'test 3',
			size: 20,
			color: '#00C952',
		},
		{
			lat: 2.817329931582864,
			lng: -60.6668476055896,
			name: 'test 4',
			size: 100,
			color: '#366CFA',
		},
		{
			lat: 2.816954876139581,
			lng: -60.66986240832538,
			name: 'test 5',
			size: 30,
			color: '#366CFA',
		},
	];

	const [centerPosition, setCenterPosition] = useState({
		lat: 2.8177854,
		lng: -60.6710493,
	});

	const [zoom, setZoom] = useState(15);*/

	const [filtroDia, setFiltroDia] = useState('hoje');

	const [cartaoInfo, setCartaoInfo] = useState<DashResumeType | undefined>();
	const [loadingDataCartao, setLoadingDataCartao] = useState(true);

	const [rangeHeader, setRangeHeader] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);

	async function getDashCartao() {
		setLoadingDataCartao(true);

		let dataCartaoPre = moment(rangeHeader[0].startDate).format('YYYY-MM-DD');
		let dataCartao = moment(rangeHeader[0].endDate).format('YYYY-MM-DD');

		try {
			const response = await api.get(
				`/admin/dashboard/resume?start=${dataCartaoPre}&end=${dataCartao}`
			);
			const { data, status } = response;
			////console.log(response);

			if (status === 200 && data && data.resumo && data.tipo && data.conta) {
				const newData = response.data;
				// console.log(newData);
				setCartaoInfo(newData);
			}
			setLoadingDataCartao(false);
		} catch (error: any) {
			//alert('Error: ' + error);
			if (error && error.response && error.response.status === 401) {
				window.location.reload();
			}
			setLoadingDataCartao(false);
		}
	}

	function handleRange(dia: string) {
		const p = [
			{
				dia: 'hoje',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: 'ontem',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().subtract(1, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().subtract(1, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: 'este mês',
				f: function () {
					setRangeHeader([
						{
							startDate: moment().startOf('month').toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === dia);
		if (item) {
			item.f();
		}
	}

	const headerData = [
		{ dia: 'hoje' },
		{ dia: 'ontem' },
		{ dia: 'este mês' },
		//{ dia: 'personalizado', personalizado: true },
	];

	useEffect(() => {
		getDashCartao();
		// getDashOperacao();
	}, [rangeHeader]);

	function renderMoneyABS(value: any) {
		value = parseFloat(value);
		return Math.abs(value).toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}
	/*
	function renderMoneyFloat(value: number) {
		return Math.abs(value).toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}
*/
	function calcPercentage(a: number, b: number) {
		return 100 * Math.abs((a - b) / ((a + b) / 2)) || 0;
	}

	return (
		<S.Container>
			<S.Header className='mr-30'>
				<S.HeaderContainer>
					<S.HeaderTitle>Dashboard</S.HeaderTitle>

					<div className='flex-row-align-center'>
						{headerData.map((data) => {
							return (
								<S.HeaderButton
									key={data.dia}
									onClick={(e) => {
										e.preventDefault();
										setFiltroDia(data.dia);
										handleRange(data.dia);
									}}
									active={data.dia === filtroDia}>
									<p>{data.dia}</p>
								</S.HeaderButton>
							);
						})}

						<SingleDropdownCalendar
							item={filtroDia}
							setItem={setFiltroDia}
							range={rangeHeader}
							setRange={setRangeHeader}
						/>
					</div>
				</S.HeaderContainer>
				<HeaderUserButton />
			</S.Header>

			<S.Body>
				<div
					className='mr-30'
					style={{ display: 'flex', flexDirection: 'row' }}>
					<TicketTransacoes />
					<div style={{ flex: 1 }} className='ml-15'>
						{loadingDataCartao || cartaoInfo === undefined ? (
							<S.RowCards>
								<S.CardWithoutFlex style={{ width: '34%' }}>
									<S.CardItem>
										<S.CardMeasureTitle>R$ Transacionados</S.CardMeasureTitle>
										<S.GreenLine />
										<S.CardValue>
											<S.Skeleton style={{ height: 32, width: 60 }} />
										</S.CardValue>
										<S.CardPercentageContainer>
											<S.Skeleton style={{ height: 24, width: 40 }} />
										</S.CardPercentageContainer>
									</S.CardItem>
								</S.CardWithoutFlex>
								<S.CardWithoutFlex className='ml-15' style={{ width: '66%' }}>
									<S.CardItem style={{ borderRadius: 24 }}>
										<S.CardMeasureTitle>Transações</S.CardMeasureTitle>
										<S.GreenLine />
										<S.CardValue>
											<S.Skeleton style={{ height: 32, width: 60 }} />
										</S.CardValue>
										<S.CardPercentageContainer>
											<S.Skeleton style={{ height: 24, width: 40 }} />
										</S.CardPercentageContainer>
									</S.CardItem>
									<S.CardItem>
										<S.CardMeasureTitle>-</S.CardMeasureTitle>
										<S.GreenLine />
										<S.CardValue>
											<S.Skeleton style={{ height: 32, width: 60 }} />
										</S.CardValue>
										<S.CardPercentageContainer>
											<S.Skeleton style={{ height: 24, width: 40 }} />
										</S.CardPercentageContainer>
									</S.CardItem>
									<S.CardItem>
										<S.CardMeasureTitle>-</S.CardMeasureTitle>
										<S.GreenLine />

										<S.CardValue>
											<S.Skeleton style={{ height: 32, width: 60 }} />
										</S.CardValue>
										<S.CardPercentageContainer>
											<S.Skeleton style={{ height: 24, width: 40 }} />
										</S.CardPercentageContainer>
									</S.CardItem>
								</S.CardWithoutFlex>
							</S.RowCards>
						) : (
							<S.RowCards>
								<S.CardWithoutFlex style={{ width: '34%' }}>
									<S.CardItem>
										<S.CardMeasureTitle>R$ Transacionados</S.CardMeasureTitle>
										<S.GreenLine />
										<S.CardValue>
											<span>R$ </span>{' '}
											{renderMoneyABS(cartaoInfo.resumo.total.atual || '0')}
										</S.CardValue>
										<S.CardPercentageContainer
											style={{
												opacity:
													calcPercentage(
														parseFloat(cartaoInfo.resumo.total.atual || '0'),
														parseFloat(cartaoInfo.resumo.total.comparado || '0')
													) !== 0
														? 1
														: 0,
											}}>
											<S.CardPercentage
												negative={
													parseFloat(cartaoInfo.resumo.total.atual || '0') -
														parseFloat(
															cartaoInfo.resumo.total.comparado || '0'
														) <
													0
												}>
												<img
													src={TrendingUp}
													alt='up'
													className='TrendingUp'
													color='#4BAF50'
													//size='12'
													style={{ marginRight: 8 }}
												/>
												<img
													src={TrendingDown}
													alt='down'
													className='TrendingDown'
													color='#C90716'
													//size='12'
													style={{ marginRight: 8 }}
												/>
												{`${calcPercentage(
													parseFloat(cartaoInfo.resumo.total.atual || '0'),
													parseFloat(cartaoInfo.resumo.total.comparado || '0')
												).toLocaleString('pt-BR', {
													maximumFractionDigits: 2,
												})}%`}
											</S.CardPercentage>
											<span>vs periodo anterior</span>
										</S.CardPercentageContainer>
									</S.CardItem>
								</S.CardWithoutFlex>
								<S.CardWithoutFlex className='ml-15' style={{ width: '66%' }}>
									<S.CardItem className='border_right_gray'>
										<S.CardMeasureTitle>Transações</S.CardMeasureTitle>
										<S.GreenLine />
										<S.CardValue>
											{' '}
											{cartaoInfo.resumo.quantidade.atual || '0'}
										</S.CardValue>
										<S.CardPercentageContainer
											style={{
												opacity:
													calcPercentage(
														parseFloat(
															cartaoInfo.resumo.quantidade.atual || '0'
														),
														parseFloat(
															cartaoInfo.resumo.quantidade.comparado || '0'
														)
													) !== 0
														? 1
														: 0,
											}}>
											<S.CardPercentage
												negative={
													parseFloat(
														cartaoInfo.resumo.quantidade.atual || '0'
													) -
														parseFloat(
															cartaoInfo.resumo.quantidade.comparado || '0'
														) <
													0
												}>
												<img
													src={TrendingUp}
													alt='up'
													className='TrendingUp'
													color='#4BAF50'
													//size='12'
													style={{ marginRight: 8 }}
												/>
												<img
													src={TrendingDown}
													alt='down'
													className='TrendingDown'
													color='#C90716'
													//size='12'
													style={{ marginRight: 8 }}
												/>
												{`${calcPercentage(
													parseFloat(cartaoInfo.resumo.quantidade.atual || '0'),
													parseFloat(
														cartaoInfo.resumo.quantidade.comparado || '0'
													)
												).toLocaleString('pt-BR', {
													maximumFractionDigits: 2,
												})}%`}
											</S.CardPercentage>
											<span></span>
										</S.CardPercentageContainer>
									</S.CardItem>

									<CardRowScroll porConta={cartaoInfo.conta} />
								</S.CardWithoutFlex>
							</S.RowCards>
						)}
						{loadingDataCartao || cartaoInfo === undefined ? (
							<S.RowCards
								className='mt-12'
								style={{ display: 'flex', flexDirection: 'row' }}>
								<S.Card>
									<S.CardItem>
										<S.CardMeasureTitle>Débito</S.CardMeasureTitle>
										<S.GreenLine />
										<S.CardValue>
											<S.Skeleton style={{ height: 32, width: 60 }} />
										</S.CardValue>
										<S.CardPercentageContainer>
											<S.Skeleton style={{ height: 24, width: 60 }} />
										</S.CardPercentageContainer>
									</S.CardItem>
								</S.Card>
								<div
									className='ml-15'
									style={{ display: 'flex', flexDirection: 'row', flex: 2 }}>
									<S.Card>
										<S.CardItem>
											<S.CardMeasureTitle>Crédito a Vista</S.CardMeasureTitle>
											<S.GreenLine />
											<S.CardValue>
												<S.Skeleton style={{ height: 32, width: 60 }} />
											</S.CardValue>
											<S.CardPercentageContainer>
												<S.Skeleton style={{ height: 24, width: 60 }} />
											</S.CardPercentageContainer>
										</S.CardItem>
									</S.Card>
									<S.Card className='ml-15'>
										<S.CardItem>
											<S.CardMeasureTitle>Crédito Parcelado</S.CardMeasureTitle>
											<S.GreenLine />
											<S.CardValue>
												<S.Skeleton style={{ height: 32, width: 60 }} />{' '}
											</S.CardValue>
											<S.CardPercentageContainer>
												<S.Skeleton style={{ height: 24, width: 60 }} />
											</S.CardPercentageContainer>
										</S.CardItem>
									</S.Card>
								</div>
							</S.RowCards>
						) : (
							<RowCardType porTipo={cartaoInfo.tipo} />
						)}
					</div>
				</div>

				<S.FooterDash
					/*onMouseDown={subCardMouse}
					ref={SubCardRef}*/
					className='mr-30'>
					<CardGrid />
					<div
						className='ml-15'
						style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
						{/*<S.MapContainer>
							<GoogleMapReact
								bootstrapURLKeys={{ key: process.env.REACT_APP_GM_KEY || '' }}
								center={centerPosition}
								zoom={zoom}
								options={{
									disableDefaultUI: true,
									zoomControl: false,
									mapTypeControl: false,
									scaleControl: false,
									streetViewControl: false,
									rotateControl: false,
									fullscreenControl: false,
									//keyboardShortcuts: false,
									//mapTypeControlOptions: false,
									//scrollwheel: false,
									//panControl: false,
									//mapTypeControl: false,
								}}>
								{testMarkers.map((tm) => {
									return (
										<Marker
											lat={tm.lat}
											lng={tm.lng}
											size={tm.size}
											name={tm.name}
											color={tm.color}></Marker>
									);
								})}
							</GoogleMapReact>
							<GeneralCard />

							<S.MapContainerLegend>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										marginRight: 8,
									}}>
									<div
										className='dot_circle'
										style={{ background: '#366CFA' }}
									/>
									Maquininhas e TECs
								</div>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<div
										className='dot_circle'
										style={{ background: '#00C952' }}
									/>
									Site e APP
								</div>
							</S.MapContainerLegend>

							<S.MapContainerFooter>
								Valores transacionados nos pontos de venda instalados em cada
								cidade.
							</S.MapContainerFooter>
						</S.MapContainer>*/}
						{
							//						<div style={{flex:1}}  className='dash_footer_row mt-15'>
						}
						<div className='dash_footer_row dash_footer_sub_item '>
							<TransacoesSemMaquina />

							<TransacoesDuplicadas />
						</div>
					</div>
				</S.FooterDash>
			</S.Body>
		</S.Container>
	);
}

function TransacoesDuplicadas() {
	const [range, setRange] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);
	// const [loading, setLoading] = useState(false);
	const [transacoes, setTransacoes] = useState<TDupli | undefined>();

	// const weekdays = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];

	////console.log(moment(range[0].startDate).format('DD/MM/YYYY'));

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [timeline, setTimeline] = useState<any[]>([]);
	//const [loadingTimeline, setLoadingTimeline] = useState(false);

	useEffect(() => {
		setDateDropdown(false);
	}, [range]);

	const [selectedDate, setSelectedDate] = useState('7 dias');

	useEffect(() => {
		const p = [
			{
				dia: '7 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(7, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '15 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(15, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '30 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(30, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === selectedDate);
		if (item) {
			item.f();
		}

		// ////console.log(selectedDate);
	}, [selectedDate]);

	const selectsDates = ['7 dias', '15 dias', '30 dias', 'Personalizado'];

	const [dateDropdown, setDateDropdown] = useState(false);

	const dropdownRef = useRef<any>(null);

	useOutsideAlert(dropdownRef, handleClickOutsideEmpresa);
	function handleClickOutsideEmpresa(e: any) {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setDateDropdown(false);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [chartData, setChartData] = useState<any>([]);

	function dateToBR(date: string) {
		return date.split('-').reverse().join('/');
	}

	function insertChartData() {
		if (timeline.length > 0) {
			let x = timeline.map((tl) => {
				if (tl.status === 'PAID') {
					return 'Transações totais';
				} else if (tl.status === 'CHARGEBACK') {
					return 'Chargebacks';
				}

				return tl.status;
			});

			x = ['x', ...x];

			const yarray = timeline.map((tl) => tl.result);

			////console.log('yArray', yarray);

			const time = yarray.map((ya) => ya.map((a: any) => a.total));

			//console.log(time, 'time');

			let y = [] as any[];

			for (let i = 0; i < time[0].length; i++) {
				let temp = [dateToBR(yarray[0][i].date.substr(5))] as any[];

				time.forEach((t) => {
					temp = [...temp, parseFloat(t[i])];
				});

				y = [...y, temp];
				//y = [...y, [time.forEach((t) => t[i])]];
			}

			//console.log(y,'ytemp')

			let finalArray = [[...x]];

			y.forEach((fe) => {
				finalArray = [...finalArray, fe];
			});

			//console.log('final array',finalArray)

			setChartData(finalArray);
		}
	}

	useEffect(() => {
		insertChartData();
	}, [timeline]);

	function DayDifferece() {
		const r = range[0];

		const a = moment(r.startDate);
		const b = moment(r.endDate);

		const c = a.diff(b, 'days');

		return Math.abs(c);
	}

	function handleDate(d: Date) {
		const m = moment(d).format('DD/MM/YYYY');

		let format = '';

		const split = m.split('/');

		format = split[0].replace('0', '');

		const months = [
			{ value: '01', name: 'Janeiro' },
			{ value: '02', name: 'Fevereiro' },
			{ value: '03', name: 'Março' },
			{ value: '04', name: 'Abril' },
			{ value: '05', name: 'Maio' },
			{ value: '06', name: 'Junho' },
			{ value: '07', name: 'Julho' },
			{ value: '08', name: 'Agosto' },
			{ value: '09', name: 'Setembro' },
			{ value: '10', name: 'Outubro' },
			{ value: '11', name: 'Novembro' },
			{ value: '12', name: 'Dezembro' },
		];

		const month = months.find((mon) => mon.value === split[1]);
		if (month) {
			format = `${format} de ${month.name}`;
		} else {
			format = `${format} de ${split[1]}`;
		}

		format = `${format} de ${split[2]}`;

		return format;
	}

	async function getTransacoes() {
		// setLoading(true);

		let dataPre = moment(range[0].startDate).format('YYYY-MM-DD');
		let dataPos = moment(range[0].endDate).format('YYYY-MM-DD');

		try {
			const response = await api.get(
				`/admin/dashboard/pendentes?start=${dataPre}&end=${dataPos}`
			);
			if (
				response.data &&
				response.data &&
				response.data.duplicada &&
				response.data.nao_identificado &&
				response.data.total
			) {
				setTransacoes(response.data);
			}
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getTransacoes();
	}, [range]);

	function renderMoneyABS(value: any) {
		value = parseFloat(value);
		return Math.abs(value).toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	function calcPercentageOf(a: number, b: number) {
		if (a === 0) return 0;
		return (100 * b) / a;
	}

	const [modalVisible, setModalVisible] = useState(false);
	return (
		<S.CardColumn className='ml-15' style={{ marginRight: 0 }}>
			<S.CardItem>
				<S.RowBetween>
					{selectedDate === 'Personalizado' && modalVisible && (
						<CalendarModal
							modalVisible={modalVisible}
							range={range}
							setRange={setRange}
							setModalVisible={setModalVisible}
						/>
					)}
					<div>
						<S.SubCardTitle>Transações Duplicadas</S.SubCardTitle>
						<div
							className='footerGridDateLabel'
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							//pressed={dateDropdown}
							//active={empresa.value !== ''}
						>
							{selectedDate === 'Hoje'
								? `hoje,${handleDate(range[0].startDate)}`
								: selectedDate === 'Personalizado'
								? `${
										DayDifferece() === 0
											? `${handleDate(range[0].startDate)}`
											: `${moment(range[0].startDate).format(
													'DD/MM/YYYY'
											  )} - ${moment(range[0].endDate).format('DD/MM/YYYY')}`
								  }`
								: `Últimos ${selectedDate}`}
						</div>
						<S.GreenLine />
					</div>
					<Dropdown ref={dropdownRef} drop='down' show={dateDropdown}>
						<Dropdown.Toggle className='dropdown-dash-toggle'>
							<S.SearchElip
								style={{ marginRight: 0 }}
								onClick={(e) => {
									e.preventDefault();
									setDateDropdown(!dateDropdown);
								}}
								pressed={dateDropdown}
								//active={empresa.value !== ''}
							>
								<img
									style={{ width: 24, height: 24 }}
									alt='.'
									src={MoreVertBlack}
								/>
							</S.SearchElip>
						</Dropdown.Toggle>

						<DropdownMenu
							style={{
								background: 'transparent',
								border: 0,
								marginTop: -10,
								display: 'flex',
							}}>
							<S.SelectMenu>
								{selectsDates.map((sd) => {
									return (
										<Dropdown.Item
											style={{ padding: 0 }}
											//className='dropdown-item-categoria'
											onClick={(a) => {
												a.preventDefault();
												a.stopPropagation();
												setSelectedDate(sd);
												//console.log('2');

												setDateDropdown(false);
												if (sd === 'Personalizado') setModalVisible(true);
											}}>
											<S.SelectItem active={sd === selectedDate}>
												{sd}
											</S.SelectItem>
										</Dropdown.Item>
									);
								})}
							</S.SelectMenu>
						</DropdownMenu>
					</Dropdown>
				</S.RowBetween>
				<S.CardValue>
					{transacoes && transacoes.duplicada
						? transacoes.duplicada.total || '0'
						: '0'}
				</S.CardValue>
				<S.CardValue>
					<span>R$ </span>{' '}
					{transacoes && transacoes.duplicada
						? renderMoneyABS(transacoes.duplicada.valor || '0')
						: '0,00'}
				</S.CardValue>

				<S.CardPercentageContainer>
					<S.CardPercentage negative={false}>
						<img
							src={DataSaverGreen}
							alt='up'
							className='TrendingUp'
							color='#4BAF50'
							//size='12'
						/>
						<img
							src={DataSaverRed}
							alt='down'
							className='TrendingDown'
							color='#C90716'
							//size='12'
							style={{}}
						/>
						<span>
							{calcPercentageOf(
								transacoes ? parseFloat(transacoes.total || '0') : 0,
								transacoes && transacoes.duplicada
									? parseFloat(transacoes.duplicada.total || '0')
									: 0
							).toLocaleString('pt-BR', {
								maximumFractionDigits: 2,
							})}
							% das transações
						</span>
					</S.CardPercentage>
				</S.CardPercentageContainer>
			</S.CardItem>
		</S.CardColumn>
	);
}

function TransacoesSemMaquina() {
	const [range, setRange] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [loading, setLoading] = useState(false);

	const [transacoes, setTransacoes] = useState<TDupli | undefined>();

	// const weekdays = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];

	////console.log(moment(range[0].startDate).format('DD/MM/YYYY'));

	/*async function getTransactionTimeline() {
		const token = sessionStorage.getItem('@bill-token');

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};

		const startDate = moment(range[0].startDate).format('YYYY-MM-DD');
		const endDate = moment(range[0].endDate).format('YYYY-MM-DD');

		setLoadingTimeline(true);

		try {
			const response = await api.get(
				`/admin/api/transaction/measure/timeline?start=${startDate}&end=${endDate}`,
				config
			);
			//console.log(response.data);
			if (response.data) {
				setTimeline(response.data);
			}

			setLoadingTimeline(false);
		} catch (error:any) {
			console.error(error);
			setLoadingTimeline(false);
		}
	}*/
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [timeline, setTimeline] = useState<any[]>([]);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars

	useEffect(() => {
		//	getTransactionTimeline();
		setDateDropdown(false);
	}, [range]);

	const [selectedDate, setSelectedDate] = useState('7 dias');

	useEffect(() => {
		const p = [
			{
				dia: '7 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(7, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '15 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(15, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '30 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(30, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === selectedDate);
		if (item) {
			item.f();
		}

		// ////console.log(selectedDate);
	}, [selectedDate]);

	const selectsDates = ['7 dias', '15 dias', '30 dias', 'Personalizado'];

	const [dateDropdown, setDateDropdown] = useState(false);

	const dropdownRef = useRef<any>(null);

	useOutsideAlert(dropdownRef, handleClickOutsideEmpresa);
	function handleClickOutsideEmpresa(e: any) {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setDateDropdown(false);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [chartData, setChartData] = useState<any>([]);

	function dateToBR(date: string) {
		return date.split('-').reverse().join('/');
	}

	function insertChartData() {
		if (timeline.length > 0) {
			let x = timeline.map((tl) => {
				if (tl.status === 'PAID') {
					return 'Transações totais';
				} else if (tl.status === 'CHARGEBACK') {
					return 'Chargebacks';
				}

				return tl.status;
			});

			x = ['x', ...x];

			const yarray = timeline.map((tl) => tl.result);

			////console.log('yArray', yarray);

			const time = yarray.map((ya) => ya.map((a: any) => a.total));

			//console.log(time, 'time');

			let y = [] as any[];

			for (let i = 0; i < time[0].length; i++) {
				let temp = [dateToBR(yarray[0][i].date.substr(5))] as any[];

				time.forEach((t) => {
					temp = [...temp, parseFloat(t[i])];
				});

				y = [...y, temp];
				//y = [...y, [time.forEach((t) => t[i])]];
			}

			//console.log(y,'ytemp')

			let finalArray = [[...x]];

			y.forEach((fe) => {
				finalArray = [...finalArray, fe];
			});

			//console.log('final array',finalArray)

			setChartData(finalArray);
		}
	}

	useEffect(() => {
		insertChartData();
	}, [timeline]);

	function DayDifferece() {
		const r = range[0];

		const a = moment(r.startDate);
		const b = moment(r.endDate);

		const c = a.diff(b, 'days');

		return Math.abs(c);
	}

	function handleDate(d: Date) {
		const m = moment(d).format('DD/MM/YYYY');

		let format = '';

		const split = m.split('/');

		format = split[0].replace('0', '');

		const months = [
			{ value: '01', name: 'Janeiro' },
			{ value: '02', name: 'Fevereiro' },
			{ value: '03', name: 'Março' },
			{ value: '04', name: 'Abril' },
			{ value: '05', name: 'Maio' },
			{ value: '06', name: 'Junho' },
			{ value: '07', name: 'Julho' },
			{ value: '08', name: 'Agosto' },
			{ value: '09', name: 'Setembro' },
			{ value: '10', name: 'Outubro' },
			{ value: '11', name: 'Novembro' },
			{ value: '12', name: 'Dezembro' },
		];

		const month = months.find((mon) => mon.value === split[1]);
		if (month) {
			format = `${format} de ${month.name}`;
		} else {
			format = `${format} de ${split[1]}`;
		}

		format = `${format} de ${split[2]}`;

		return format;
	}
	const [modalVisible, setModalVisible] = useState(false);

	async function getTransacoes() {
		setLoading(true);

		let dataPre = moment(range[0].startDate).format('YYYY-MM-DD');
		let dataPos = moment(range[0].endDate).format('YYYY-MM-DD');

		try {
			const response = await api.get(
				`/admin/dashboard/pendentes?start=${dataPre}&end=${dataPos}`
			);
			if (
				response.data &&
				response.data &&
				response.data.duplicada &&
				response.data.nao_identificado &&
				response.data.total
			) {
				setTransacoes(response.data);
			}
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getTransacoes();
	}, [range]);

	function renderMoneyABS(value: any) {
		value = parseFloat(value);
		return Math.abs(value).toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	function calcPercentageOf(a: number, b: number) {
		if (a === 0) return 0;
		return (100 * b) / a;
	}

	return (
		<S.CardColumn style={{ marginRight: 0 }}>
			<S.CardItem>
				<S.RowBetween>
					{selectedDate === 'Personalizado' && modalVisible && (
						<CalendarModal
							modalVisible={modalVisible}
							range={range}
							setRange={setRange}
							setModalVisible={setModalVisible}
						/>
					)}
					<div>
						<S.SubCardTitle>Transações sem a Maquina</S.SubCardTitle>
						<div
							className='footerGridDateLabel'
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							//pressed={dateDropdown}
							//active={empresa.value !== ''}
						>
							{selectedDate === 'Hoje'
								? `hoje,${handleDate(range[0].startDate)}`
								: selectedDate === 'Personalizado'
								? `${
										DayDifferece() === 0
											? `${handleDate(range[0].startDate)}`
											: `${moment(range[0].startDate).format(
													'DD/MM/YYYY'
											  )} - ${moment(range[0].endDate).format('DD/MM/YYYY')}`
								  }`
								: `Últimos ${selectedDate}`}
						</div>
						<S.GreenLine />
					</div>
					<Dropdown ref={dropdownRef} drop='down' show={dateDropdown}>
						<Dropdown.Toggle className='dropdown-dash-toggle'>
							<S.SearchElip
								style={{ marginRight: 0 }}
								onClick={(e) => {
									e.preventDefault();
									setDateDropdown(!dateDropdown);
								}}
								pressed={dateDropdown}
								//active={empresa.value !== ''}
							>
								<img
									style={{ width: 24, height: 24 }}
									alt='.'
									src={MoreVertBlack}
								/>
							</S.SearchElip>
						</Dropdown.Toggle>

						<DropdownMenu
							style={{
								background: 'transparent',
								border: 0,
								marginTop: -10,
								display: 'flex',
							}}>
							<S.SelectMenu>
								{selectsDates.map((sd) => {
									return (
										<Dropdown.Item
											style={{ padding: 0 }}
											//className='dropdown-item-categoria'
											onClick={(a) => {
												a.preventDefault();
												a.stopPropagation();
												setSelectedDate(sd);
												//console.log('2');

												setDateDropdown(false);
												if (sd === 'Personalizado') setModalVisible(true);
											}}>
											<S.SelectItem active={sd === selectedDate}>
												{sd}
											</S.SelectItem>
										</Dropdown.Item>
									);
								})}
							</S.SelectMenu>
						</DropdownMenu>
					</Dropdown>
				</S.RowBetween>
				<S.CardValue>
					{transacoes && transacoes.nao_identificado
						? transacoes.nao_identificado.total || '0'
						: '0'}
				</S.CardValue>
				<S.CardValue>
					<span>R$ </span>
					{transacoes && transacoes.nao_identificado
						? renderMoneyABS(transacoes.nao_identificado.valor || '0')
						: '0,00'}
				</S.CardValue>

				<S.CardPercentageContainer>
					<S.CardPercentage negative={false}>
						<img
							src={DataSaverGreen}
							alt='up'
							className='TrendingUp'
							color='#4BAF50'
							//size='12'
						/>
						<img
							src={DataSaverRed}
							alt='down'
							className='TrendingDown'
							color='#C90716'
							//size='12'
							style={{}}
						/>
						<span>
							{calcPercentageOf(
								transacoes ? parseFloat(transacoes.total || '0') : 0,
								transacoes
									? parseFloat(transacoes.nao_identificado.total || '0')
									: 0
							).toLocaleString('pt-BR', {
								maximumFractionDigits: 2,
							})}
							% das transações
						</span>
					</S.CardPercentage>
				</S.CardPercentageContainer>

				{/*
				<ListRank>
					{rankInfo.data.map((item) => {
						let maxV = 0;

						for (let i = 0; i < rankInfo.data.length; i++) {
							if (rankInfo.data[i].valor > maxV) {
								maxV = rankInfo.data[i].valor;
							}
						}
						let w = '0%';
						//////console.log(maxV);

						if (maxV === item.valor) {
							w = '100%';
						} else {
							let n = (item.valor * 100) / maxV;
							w = `${n}%`;
						}

						//////console.log(w);

						return (
							<div
								key={item.unidade}
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									marginBlock: 8,
								}}>
								<ListRankTextLight
									className='ranking-text-light'
									style={{ flex: 1.5 }}>
									{item.unidade}
								</ListRankTextLight>
								<div style={{ flex: 5 }}>
									<div
										style={{
											width: w,
											background: '#09AA36',
											height: 8,
											borderRadius: 5,
										}}
									/>
								</div>
								{
									<NumberFormat
										className='ranking-text-medium'
										value={item.valor}
										thousandSeparator='.'
										decimalSeparator=','
										decimalScale={2}
										fixedDecimalScale={true}
										prefix='R$ '
										displayType='text'
										//isAllowed={false}
										style={{
											flex: 2,
										}}></NumberFormat>
								}
							</div>
						);
					})}
				</ListRank>
*/}
			</S.CardItem>
		</S.CardColumn>
	);
}

function CardGrid() {
	const [range, setRange] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);

	const [transacoesChargeback, setTransacoesChargeback] = useState<
		DashTransacaoChargeback | undefined
	>();
	////console.log(moment(range[0].startDate).format('DD/MM/YYYY'));

	async function getTransactionChargeback() {
		const token = sessionStorage.getItem('@bill-token');

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};

		const startDate = moment(range[0].startDate).format('YYYY-MM-DD');
		const endDate = moment(range[0].endDate).format('YYYY-MM-DD');

		setLoadingTimeline(true);

		try {
			const response = await api.get(
				`/admin/dashboard/chargeback?start=${startDate}&end=${endDate}`,
				config
			);
			//console.log(response.data);
			if (response.data && response.data.chargebacks && response.data.paids) {
				// setTimeline(response.data);
				setTransacoesChargeback(response.data);
			}

			setLoadingTimeline(false);
		} catch (error: any) {
			console.error(error);
			setLoadingTimeline(false);
		}
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [loadingTimeline, setLoadingTimeline] = useState(false);

	useEffect(() => {
		getTransactionChargeback();
		setDateDropdown(false);
	}, [range]);

	const [selectedDate, setSelectedDate] = useState('7 dias');

	useEffect(() => {
		const p = [
			{
				dia: '7 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(7, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '15 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(15, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '30 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(30, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === selectedDate);
		if (item) {
			item.f();
		}

		// ////console.log(selectedDate);
	}, [selectedDate]);

	const selectsDates = ['7 dias', '15 dias', '30 dias', 'Personalizado'];

	const [dateDropdown, setDateDropdown] = useState(false);

	const dropdownRef = useRef<any>(null);

	useOutsideAlert(dropdownRef, handleClickOutsideEmpresa);
	function handleClickOutsideEmpresa(e: any) {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setDateDropdown(false);
		}
	}

	const [chartData, setChartData] = useState<any>([]);

	function dateToBR(date: string) {
		return date.split('-').reverse().join('/');
	}

	function insertChartData() {
		if (transacoesChargeback) {
			let t = [];
			t.push(['Periodo', 'Chargeback', 'Transações']);
			transacoesChargeback.chargebacks.forEach((c, index) => {
				t.push([
					dateToBR(c.cadastro),
					parseFloat(c.total),
					parseFloat(transacoesChargeback.paids[index].total),
				]);
			});

			setChartData(t);
		}
	}

	useEffect(() => {
		insertChartData();
	}, [transacoesChargeback]);

	function DayDifferece() {
		const r = range[0];

		const a = moment(r.startDate);
		const b = moment(r.endDate);

		const c = a.diff(b, 'days');

		return Math.abs(c);
	}

	function handleDate(d: Date) {
		const m = moment(d).format('DD/MM/YYYY');

		let format = '';

		const split = m.split('/');

		format = split[0].replace('0', '');

		const months = [
			{ value: '01', name: 'Janeiro' },
			{ value: '02', name: 'Fevereiro' },
			{ value: '03', name: 'Março' },
			{ value: '04', name: 'Abril' },
			{ value: '05', name: 'Maio' },
			{ value: '06', name: 'Junho' },
			{ value: '07', name: 'Julho' },
			{ value: '08', name: 'Agosto' },
			{ value: '09', name: 'Setembro' },
			{ value: '10', name: 'Outubro' },
			{ value: '11', name: 'Novembro' },
			{ value: '12', name: 'Dezembro' },
		];

		const month = months.find((mon) => mon.value === split[1]);
		if (month) {
			format = `${format} de ${month.name}`;
		} else {
			format = `${format} de ${split[1]}`;
		}

		format = `${format} de ${split[2]}`;

		return format;
	}

	const [modalVisible, setModalVisible] = useState(false);

	return (
		<S.CardColumn className='dash_footer_item' style={{ marginRight: 0 }}>
			<S.CardItem className='left_card_item'>
				<S.RowBetween>
					{selectedDate === 'Personalizado' && modalVisible && (
						<CalendarModal
							modalVisible={modalVisible}
							range={range}
							setRange={setRange}
							setModalVisible={setModalVisible}
						/>
					)}
					<div>
						<S.CardTitle>Transações e Chargeback</S.CardTitle>
						<div
							className='footerGridDateLabel'
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							//pressed={dateDropdown}
							//active={empresa.value !== ''}
						>
							{selectedDate === 'Hoje'
								? `hoje,${handleDate(range[0].startDate)}`
								: selectedDate === 'Personalizado'
								? `${
										DayDifferece() === 0
											? `${handleDate(range[0].startDate)}`
											: `${moment(range[0].startDate).format(
													'DD/MM/YYYY'
											  )} - ${moment(range[0].endDate).format('DD/MM/YYYY')}`
								  }`
								: `Últimos ${selectedDate}`}
						</div>
					</div>
					<Dropdown ref={dropdownRef} drop='down' show={dateDropdown}>
						<Dropdown.Toggle className='dropdown-dash-toggle'>
							<S.SearchSelector
								onClick={(e) => {
									e.preventDefault();
									setDateDropdown(!dateDropdown);
								}}
								pressed={dateDropdown}
								//active={empresa.value !== ''}
							>
								{selectedDate}
								<img className='ExportArrowDown' alt='' src={ArrowDownDark} />
							</S.SearchSelector>
						</Dropdown.Toggle>

						<DropdownMenu
							style={{
								background: 'transparent',
								border: 0,
								marginTop: -10,
								display: 'flex',
							}}>
							<S.SelectMenu>
								{selectsDates.map((sd) => {
									return (
										<Dropdown.Item
											style={{ padding: 0 }}
											//className='dropdown-item-categoria'
											onClick={(a) => {
												a.preventDefault();
												a.stopPropagation();
												setSelectedDate(sd);
												//console.log('2');
												setDateDropdown(false);
												if (sd === 'Personalizado') setModalVisible(true);
											}}>
											<S.SelectItem active={sd === selectedDate}>
												{sd}
											</S.SelectItem>
										</Dropdown.Item>
									);
								})}
							</S.SelectMenu>
						</DropdownMenu>
					</Dropdown>
				</S.RowBetween>

				<S.ListRank>
					<Chart
						chartType='LineChart'
						height={'100%'}
						width='100%'
						data={chartData}
						options={{
							title: 'Transações e Chargeback',
							hAxis: {
								title: 'Periodo',
								titleTextStyle: {
									color: '#222222',
									fontSize: 13,
									fontWeight: 500,
									fontFamily: 'Roboto',
								},
								minValue: 0,
							},

							vAxis: { minValue: 0 },
							// For the legend to fit, we make the chart area smaller
							chartArea: { width: '80%', height: '70%' },
							series: {
								1: { curveType: 'function' },
								0: { curveType: 'function' },
								4: { curveType: 'function' },
								5: { curveType: 'function' },
								6: { curveType: 'function' },
								2: { curveType: 'function' },
								3: { curveType: 'function' },
							},
							legend: 'none' //{position: 'bottom',maxLines: 3,},
							// lineWidth: 25
						}}
						// For tests
						rootProps={{ 'data-testid': '1' }}
					/>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyContent: 'center',
						}}>
						<S.LegendLabel
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
							}}
							color='#222222'>
							{' '}
							<div
								style={{
									width: 15,
									height: 3,
									background: 'rgb(51,102,204)',
									marginRight: 4,
								}}
							/>{' '}
							Chargeback
						</S.LegendLabel>
						<S.LegendLabel
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								marginLeft: 8,
							}}
							color='#222222'>
							{' '}
							<div
								style={{
									width: 15,
									height: 3,
									background: 'rgb(220,57,18)',
									marginRight: 4,
								}}
							/>{' '}
							Transações
						</S.LegendLabel>
					</div>
				</S.ListRank>
			</S.CardItem>

			<Conciliacoes />
		</S.CardColumn>
	);
}
/*
function GeneralCard() {
	const [loading, setLoading] = useState(false);

	const [transactionTotal, setTransactionTotal] = useState<TransactionTotal[]>(
		[]
	);
	const [range, setRange] = useState([
		{
			startDate: moment(
				moment().subtract(7, 'days').format('DD/MM/YYYY'),
				'DD/MM/YYYY'
			).toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);

	////console.log(moment(range[0].startDate).format('DD/MM/YYYY'));

	useEffect(() => {
		//getTransactionTimeline();

		setDateDropdown(false);
	}, [range]);

	const [selectedDate, setSelectedDate] = useState('Hoje');

	useEffect(() => {
		const p = [
			{
				dia: 'Hoje',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},

			{
				dia: '7 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(7, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '15 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(15, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '30 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(30, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === selectedDate);
		if (item) {
			item.f();
		}

		// ////console.log(selectedDate);
	}, [selectedDate]);

	const selectsDates = [
		'Hoje',
		'7 dias',
		'15 dias',
		'30 dias',
		'Personalizado',
	];

	const [dateDropdown, setDateDropdown] = useState(false);

	const dropdownRef = useRef<any>(null);

	useOutsideAlert(dropdownRef, handleClickOutsideEmpresa);
	function handleClickOutsideEmpresa(e: any) {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setDateDropdown(false);
		}
	}

	function dateToBR(date: string) {
		return date.split('-').reverse().join('/');
	}

	function DayDifferece() {
		const r = range[0];

		const a = moment(r.startDate);
		const b = moment(r.endDate);

		const c = a.diff(b, 'days');

		return Math.abs(c);
	}

	function handleDate(d: Date) {
		const m = moment(d).format('DD/MM/YYYY');

		let format = '';

		const split = m.split('/');

		format = split[0].replace('0', '');

		const months = [
			{ value: '01', name: 'Janeiro' },
			{ value: '02', name: 'Fevereiro' },
			{ value: '03', name: 'Março' },
			{ value: '04', name: 'Abril' },
			{ value: '05', name: 'Maio' },
			{ value: '06', name: 'Junho' },
			{ value: '07', name: 'Julho' },
			{ value: '08', name: 'Agosto' },
			{ value: '09', name: 'Setembro' },
			{ value: '10', name: 'Outubro' },
			{ value: '11', name: 'Novembro' },
			{ value: '12', name: 'Dezembro' },
		];

		const month = months.find((mon) => mon.value === split[1]);
		if (month) {
			format = `${format} de ${month.name}`;
		} else {
			format = `${format} de ${split[1]}`;
		}

		format = `${format} de ${split[2]}`;

		return format;
	}

	function TypeRank(label: string) {
		const data = [
			{
				label: 'Total transacionado',
				value: 'total',
			},
			{
				label: 'Ticket médio',
				value: 'ticket',
			},
			{
				label: 'Qtd. de pagamentos',
				value: 'quantity',
			},
		];
		const finder = data.find((d) => d.label === label);
		if (finder) return finder.value;
		else return '';
	}

	async function getTransaction() {
		setLoading(true);

		let dataPre = moment(range[0].startDate).format('DD/MM/YYYY');
		let dataPos = moment(range[0].endDate).format('DD/MM/YYYY');

		const t = TypeRank('Total transacionado');

		try {
			const response = await api.get(
				`/admin/dashboard/ranking?data_inicial=${dataPre}&data_final=${dataPos}&type=${t}`
			);
			if (response.status === 200) {
				if (response.data) {
					setTransactionTotal([...response.data]);
				}
			}
		} catch (error: any) {
			console.log(error);
		}
	}

	useEffect(() => {
		getTransaction();
	}, [range]);

	function transactionsTotal() {
		let total = 0;

		transactionTotal.forEach((tt) => {
			total = total + tt.total;
		});

		return total;
	}

	const [modalVisible, setModalVisible] = useState(false);
	return (
		<S.GeneralCard style={{ marginRight: 0 }}>
			<S.CardItem style={{ maxWidth: '100%' }}>
				<S.RowBetween>
					{selectedDate === 'Personalizado' && modalVisible && (
						<CalendarModal
							modalVisible={modalVisible}
							range={range}
							setRange={setRange}
							setModalVisible={setModalVisible}
						/>
					)}
					<div>
						<S.CardTitle>{'Total Transacionado'}</S.CardTitle>
						<div
							className='footerGridDateLabel'
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							//pressed={dateDropdown}
							//active={empresa.value !== ''}
						>
							{selectedDate === 'Hoje'
								? `hoje,${handleDate(range[0].startDate)}`
								: selectedDate === 'Personalizado'
								? `${
										DayDifferece() === 0
											? `${handleDate(range[0].startDate)}`
											: `${moment(range[0].startDate).format(
													'DD/MM/YYYY'
											  )} - ${moment(range[0].endDate).format('DD/MM/YYYY')}`
								  }`
								: `Últimos ${selectedDate}`}
						</div>
					</div>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<div>
							<p className='transaction_title'>
								<span>R$</span>{' '}
								{transactionsTotal().toLocaleString('pt-BR', {
									maximumFractionDigits: 2,
									minimumFractionDigits: 2,
								})}
							</p>
							<p className='transaction_status'>ON-LINE</p>
						</div>
						<Dropdown ref={dropdownRef} drop='down' show={dateDropdown}>
							<Dropdown.Toggle className='dropdown-dash-toggle'>
								<S.SearchSelector
									onClick={(e) => {
										e.preventDefault();
										//console.log('hello')
										setDateDropdown(!dateDropdown);
									}}
									pressed={dateDropdown}
									//active={empresa.value !== ''}
								>
									{selectedDate}
									<img className='ExportArrowDown' alt='' src={ArrowDownDark} />
								</S.SearchSelector>
							</Dropdown.Toggle>

							<DropdownMenu
								style={{
									background: 'transparent',
									border: 0,
									marginTop: -10,
									display: 'flex',
								}}>
								<S.SelectMenu
									onClick={(a) => {
										a.stopPropagation();
										// console.log('aaa');
									}}>
									{selectsDates.map((sd) => {
										return (
											<Dropdown.Item
												style={{ padding: 0 }}
												//className='dropdown-item-categoria'
												onClick={(a) => {
													a.preventDefault();
													a.stopPropagation();
													console.log('hello');
													setSelectedDate(sd);
													//console.log('2');
													setDateDropdown(false);
													if (sd === 'Personalizado') setModalVisible(true);
												}}>
												<S.SelectItem active={sd === selectedDate}>
													{sd}
												</S.SelectItem>
											</Dropdown.Item>
										);
									})}
								</S.SelectMenu>
							</DropdownMenu>
						</Dropdown>
					</div>
				</S.RowBetween>
			</S.CardItem>
		</S.GeneralCard>
	);
}
*/
function TicketTransacoes() {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [loading, setLoading] = useState(false);
	const [rangeHeader, setRangeHeader] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);
	const [rankInfo, setRankInfo] = useState<DashTransactionPayment[]>([]);
	const [selectedDate, setSelectedDate] = useState('Hoje');
	const selectsDates = [
		'Hoje',
		'Ontem',
		'7 dias',
		'15 dias',
		'30 dias',
		'Personalizado',
	];
	const [dateDropdown, setDateDropdown] = useState(false);

	const dropdownRef = useRef<any>(null);
	const gridRef = useRef<any>(null);
	const { onMouseDown } = useDraggableScroll(gridRef);

	async function getDashRanking() {
		setLoading(true);

		let dataPre = moment(rangeHeader[0].startDate).format('YYYY-MM-DD');
		let dataPos = moment(rangeHeader[0].endDate).format('YYYY-MM-DD');

		try {
			const response = await api.get(
				`/admin/dashboard/ticket?start=${dataPre}&end=${dataPos}`
			);

			const { data, status } = response;
			//	console.log(response);
			if (status === 200 && data && data.ticket) {
				setRankInfo([...data.ticket]);

				//setOperacaoInfo(newData);
				//setOperacaoInfo({});
			}
			setLoading(false);
		} catch (error: any) {
			//alert('Error: ' + error);
			/**if (error.response.status === 401) {
				window.location.reload();
			}*/
			setLoading(false);
		}
	}

	useEffect(() => {
		getDashRanking();
		setDateDropdown(false);
	}, [rangeHeader]);

	useOutsideAlert(dropdownRef, handleClickOutsideEmpresa);
	function handleClickOutsideEmpresa(e: any) {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setDateDropdown(false);
		}
	}
	useEffect(() => {
		const p = [
			{
				dia: 'Hoje',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: 'Ontem',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().subtract(1, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().subtract(1, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '7 dias',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().subtract(7, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '15 dias',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().subtract(15, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '30 dias',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().subtract(30, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === selectedDate);
		if (item) {
			item.f();
		}

		// ////console.log(selectedDate);
	}, [selectedDate]);

	function DayDifferece() {
		const r = rangeHeader[0];

		const a = moment(r.startDate);
		const b = moment(r.endDate);

		const c = a.diff(b, 'days');

		return Math.abs(c);
	}

	function handleDate(d: Date) {
		const m = moment(d).format('DD/MM/YYYY');

		let format = '';

		const split = m.split('/');

		format = split[0].replace('0', '');

		const months = [
			{ value: '01', name: 'Janeiro' },
			{ value: '02', name: 'Fevereiro' },
			{ value: '03', name: 'Março' },
			{ value: '04', name: 'Abril' },
			{ value: '05', name: 'Maio' },
			{ value: '06', name: 'Junho' },
			{ value: '07', name: 'Julho' },
			{ value: '08', name: 'Agosto' },
			{ value: '09', name: 'Setembro' },
			{ value: '10', name: 'Outubro' },
			{ value: '11', name: 'Novembro' },
			{ value: '12', name: 'Dezembro' },
		];

		const month = months.find((mon) => mon.value === split[1]);
		if (month) {
			format = `${format} de ${month.name}`;
		} else {
			format = `${format} de ${split[1]}`;
		}

		format = `${format} de ${split[2]}`;

		return format;
	}

	const [modalVisible, setModalVisible] = useState(false);
	return (
		<S.BlueCard>
			<div className='blue_row blue_align_center blue_space_between'>
				<p className='blue_card_title'>Ticket Médio e Pagamentos</p>

				{selectedDate === 'Personalizado' && modalVisible && (
					<CalendarModal
						modalVisible={modalVisible}
						range={rangeHeader}
						setRange={setRangeHeader}
						setModalVisible={setModalVisible}
					/>
				)}
				<Dropdown
					ref={dropdownRef}
					drop='down'
					show={dateDropdown}
					className=' dropdown-toggle-categoria'>
					<Dropdown.Toggle>
						<div
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							className='blue_dropdown_container'>
							<UilEllipsisV />
						</div>
					</Dropdown.Toggle>
					<DropdownMenu
						style={{
							background: 'transparent',
							border: 0,
							marginTop: -10,
							display: 'flex',
						}}>
						<S.SelectMenu>
							{selectsDates.map((sd) => {
								return (
									<Dropdown.Item
										style={{ padding: 0 }}
										//className='dropdown-item-categoria'
										onClick={(a) => {
											a.preventDefault();
											a.stopPropagation();
											setSelectedDate(sd);
											//console.log('2');
											setDateDropdown(false);
											if (sd === 'Personalizado') setModalVisible(true);
										}}>
										<S.SelectItem active={sd === selectedDate}>
											{sd}
										</S.SelectItem>
									</Dropdown.Item>
								);
							})}
						</S.SelectMenu>
					</DropdownMenu>
				</Dropdown>
			</div>
			<p className='blue_label'>
				{selectedDate === 'Hoje'
					? `hoje, ${handleDate(rangeHeader[0].startDate)}`
					: selectedDate === 'Ontem'
					? `ontem, ${handleDate(rangeHeader[0].startDate)}`
					: selectedDate === 'Personalizado'
					? `${
							DayDifferece() === 0
								? `${handleDate(rangeHeader[0].startDate)}`
								: `${moment(rangeHeader[0].startDate).format(
										'DD/MM/YYYY'
								  )} - ${moment(rangeHeader[0].endDate).format('DD/MM/YYYY')}`
					  }`
					: `Últimos ${selectedDate}`}
			</p>

			<S.MerchantRank onMouseDown={onMouseDown} ref={gridRef}>
				{rankInfo.length > 0 ? (
					rankInfo.map((ri, index) => {
						console.log(ri);
						let highestAm = 0;
						let highestQtd = 0;
						let floatAm = 0;
						let floatQtd = 0;
						floatQtd = parseFloat(ri.quantidade);
						floatAm = parseFloat(ri.total) / (floatQtd > 0 ? floatQtd : 1);

						rankInfo.forEach((r) => {
							if (parseFloat(r.quantidade) > highestQtd) {
								highestQtd = parseFloat(r.quantidade);
							}
							const t =
								parseFloat(r.total) /
								(parseFloat(r.quantidade) > 0 ? parseFloat(r.quantidade) : 1);
							if (t > highestAm) {
								highestAm = t;
							}
						});

						const percentAm = (floatAm * 100) / highestAm;

						const percentQtd = (floatQtd * 100) / highestQtd;

						return (
							<div key={ri.id} className='merchant_rank_container'>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										//justifyContent: 'space-between',
										height: '100%',
										//background: "#FFF",
										width: '100%',
									}}>
									<S.MerchantLine
										background='#FFAB00'
										style={{ marginRight: 10 }}
										heightPercentage={percentAm}>
										<OverlayTrigger
											placement={
												index !== rankInfo.length - 1 ? 'right' : 'left'
											}
											overlay={
												<Tooltip id='tool-tip'>
													<span style={{ textTransform: 'capitalize' }}>
														R${' '}
														{floatAm.toLocaleString('pt-BR', {
															minimumFractionDigits: 2,
														})}
													</span>
												</Tooltip>
											}>
											<div className='merchant_rank_intern' />
										</OverlayTrigger>
									</S.MerchantLine>

									<S.MerchantLine
										background='#366CFA'
										heightPercentage={percentQtd}>
										<OverlayTrigger
											placement={
												index !== rankInfo.length - 1 ? 'right' : 'left'
											}
											overlay={
												<Tooltip id='tool-tip'>
													<span style={{ textTransform: 'capitalize' }}>
														{floatQtd}
													</span>
												</Tooltip>
											}>
											<div className='merchant_rank_intern' />
										</OverlayTrigger>
									</S.MerchantLine>
								</div>
								<p className='merchant_rank_label'>{ri.nome}</p>
							</div>
						);
					})
				) : (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}>
						<p style={{ verticalAlign: 'center' }} className='blue_card_title'>
							Sem informações para esta data
						</p>
					</div>
				)}
			</S.MerchantRank>

			<div className='blue_row blue_align_center blue_space_between'>
				<div className='blue_row blue_align_center'>
					<S.LegendDot background='#FFAB00' />
					<S.LegendLabel>Ticket Médio</S.LegendLabel>
				</div>
				<div className='blue_row blue_align_center'>
					<S.LegendDot background='#366CFA' />
					<S.LegendLabel>Qtde Pagamentos</S.LegendLabel>
				</div>
			</div>
		</S.BlueCard>
	);
}

function Conciliacoes() {
	const [selectedDate, setSelectedDate] = useState('7 dias');

	const [modalVisible, setModalVisible] = useState(false);

	const [capturas, setCapturas] = useState<DashConciliacao[]>([]);
	const [cancelamentos, setCancelamentos] = useState<DashConciliacao[]>([]);
	const [chargebacks, setChargebacks] = useState<DashConciliacao[]>([]);
	const [pagamentos, setPagamentos] = useState<DashConciliacao[]>([]);

	const [capturasTemp] = useState<DashConciliacao[]>([
		{
			total: '20',
			nome: 'Homologação',
			id: 1,
		},
		{
			total: '10',
			nome: 'Simulador',
			id: 2,
		},
	]);
	const [cancelamentosTemp] = useState<DashConciliacao[]>([
		{
			total: '2',
			nome: 'Homologação',
			id: 1,
		},
		{
			total: '5',
			nome: 'Simulador',
			id: 2,
		},
	]);
	const [chargebacksTemp] = useState<DashConciliacao[]>([
		{
			total: '10',
			nome: 'Homologação',
			id: 1,
		},
		{
			total: '12',
			nome: 'Simulador',
			id: 2,
		},
	]);
	const [pagamentosTemp] = useState<DashConciliacao[]>([
		{
			total: '15',
			nome: 'Homologação',
			id: 1,
		},
		{
			total: '22',
			nome: 'Simulador',
			id: 2,
		},
	]);

	const [range, setRange] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);
	const dropdownRef = useRef<any>(null);
	const [dateDropdown, setDateDropdown] = useState(false);

	function DayDifferece() {
		const r = range[0];

		const a = moment(r.startDate);
		const b = moment(r.endDate);

		const c = a.diff(b, 'days');

		return Math.abs(c);
	}

	function handleDate(d: Date) {
		const m = moment(d).format('DD/MM/YYYY');

		let format = '';

		const split = m.split('/');

		format = split[0].replace('0', '');

		const months = [
			{ value: '01', name: 'Janeiro' },
			{ value: '02', name: 'Fevereiro' },
			{ value: '03', name: 'Março' },
			{ value: '04', name: 'Abril' },
			{ value: '05', name: 'Maio' },
			{ value: '06', name: 'Junho' },
			{ value: '07', name: 'Julho' },
			{ value: '08', name: 'Agosto' },
			{ value: '09', name: 'Setembro' },
			{ value: '10', name: 'Outubro' },
			{ value: '11', name: 'Novembro' },
			{ value: '12', name: 'Dezembro' },
		];

		const month = months.find((mon) => mon.value === split[1]);
		if (month) {
			format = `${format} de ${month.name}`;
		} else {
			format = `${format} de ${split[1]}`;
		}

		format = `${format} de ${split[2]}`;

		return format;
	}
	const selectsDates = ['7 dias', '15 dias', '30 dias', 'Personalizado'];

	async function getConciliacoes() {
		let dataPre = moment(range[0].startDate).format('YYYY-MM-DD');
		let dataPos = moment(range[0].endDate).format('YYYY-MM-DD');

		try {
			const response = await api.get(`
				
			admin/dashboard/conciliacao?start=${dataPre}&end=${dataPos}
			`);

			const { data, status } = response;
			if (status === 200 && data) {
				if (data.capturas) {
					setCapturas(data.capturas);
				}
				if (data.cancelamentos) {
					setCancelamentos(data.cancelamentos);
				}
				if (data.chargebacks) {
					setChargebacks(data.chargebacks);
				}
				if (data.pagamentos) {
					setPagamentos(data.pagamentos);
				}
			}
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		getConciliacoes();
	}, [range]);

	function highestTotal() {
		let highest = 0;
		capturasTemp.forEach((c) => {
			const ct = parseFloat(c.total || '0');
			if (ct > highest) {
				highest = ct;
			}
		});
		cancelamentosTemp.forEach((c) => {
			const ct = parseFloat(c.total || '0');
			if (ct > highest) {
				highest = ct;
			}
		});
		chargebacksTemp.forEach((c) => {
			const ct = parseFloat(c.total || '0');
			if (ct > highest) {
				highest = ct;
			}
		});
		pagamentosTemp.forEach((p) => {
			const ct = parseFloat(p.total || '0');
			if (ct > highest) {
				highest = ct;
			}
		});

		return highest;
	}

	useEffect(() => {
		const p = [
			{
				dia: 'Hoje',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},

			{
				dia: '7 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(7, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '15 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(15, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: '30 dias',
				f: function () {
					setRange([
						{
							startDate: moment(
								moment().subtract(30, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];

		const item = p.find((d) => d.dia === selectedDate);
		if (item) {
			item.f();
		}

		// ////console.log(selectedDate);
	}, [selectedDate]);

	return (
		<S.CardItem>
			<S.RowBetween>
				<S.RowBetween>
					{selectedDate === 'Personalizado' && modalVisible && (
						<CalendarModal
							modalVisible={modalVisible}
							range={range}
							setRange={setRange}
							setModalVisible={setModalVisible}
						/>
					)}
					<div>
						<S.CardTitle>Conciliações</S.CardTitle>
						<div
							className='footerGridDateLabel'
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							//pressed={dateDropdown}
							//active={empresa.value !== ''}
						>
							{selectedDate === 'Hoje'
								? `hoje,${handleDate(range[0].startDate)}`
								: selectedDate === 'Personalizado'
								? `${
										DayDifferece() === 0
											? `${handleDate(range[0].startDate)}`
											: `${moment(range[0].startDate).format(
													'DD/MM/YYYY'
											  )} - ${moment(range[0].endDate).format('DD/MM/YYYY')}`
								  }`
								: `Últimos ${selectedDate}`}
						</div>
					</div>
				</S.RowBetween>
				<Dropdown ref={dropdownRef} drop='down' show={dateDropdown}>
					<Dropdown.Toggle className='dropdown-dash-toggle'>
						<S.SearchSelector
							onClick={(e) => {
								e.preventDefault();
								setDateDropdown(!dateDropdown);
							}}
							pressed={dateDropdown}
							//active={empresa.value !== ''}
						>
							{selectedDate}
							<img className='ExportArrowDown' alt='' src={ArrowDownDark} />
						</S.SearchSelector>
					</Dropdown.Toggle>

					<DropdownMenu
						style={{
							background: 'transparent',
							border: 0,
							marginTop: -10,
							display: 'flex',
						}}>
						<S.SelectMenu>
							{selectsDates.map((sd) => {
								return (
									<Dropdown.Item
										style={{ padding: 0 }}
										//className='dropdown-item-categoria'
										onClick={(a) => {
											a.preventDefault();
											a.stopPropagation();
											setSelectedDate(sd);
											//console.log('2');
											setDateDropdown(false);
											if (sd === 'Personalizado') setModalVisible(true);
										}}>
										<S.SelectItem active={sd === selectedDate}>
											{sd}
										</S.SelectItem>
									</Dropdown.Item>
								);
							})}
						</S.SelectMenu>
					</DropdownMenu>
				</Dropdown>
			</S.RowBetween>

			<S.ConcRank>
				<div className='merchant_rank_container'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							//justifyContent: 'space-between',
							height: '100%',
							//background: "#FFF",
							width: '100%',
						}}>
						{capturas.map((cp, index) => {
							let floatTotal = parseFloat(cp.total || '0');

							const percent = (floatTotal * 100) / highestTotal();

							return (
								<S.ConciliatorLine
									key={cp.id}
									background={index === 0 ? '#366CFA' : '#00C952'}
									style={{ marginRight: 10 }}
									heightPercentage={percent}>
									<OverlayTrigger
										placement={index !== capturas.length - 1 ? 'right' : 'left'}
										overlay={
											<Tooltip id='tool-tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{floatTotal}
												</span>
											</Tooltip>
										}>
										<div className='merchant_rank_intern' />
									</OverlayTrigger>
								</S.ConciliatorLine>
							);
						})}
					</div>

					<p style={{ color: '#000' }} className='merchant_rank_label'>
						{'Capturas'}
					</p>
				</div>
				<div className='merchant_rank_container'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							//justifyContent: 'space-between',
							height: '100%',
							//background: "#FFF",
							width: '100%',
						}}>
						{cancelamentos.map((cp, index) => {
							let floatTotal = parseFloat(cp.total || '0');

							const percent = (floatTotal * 100) / highestTotal();

							return (
								<S.ConciliatorLine
									key={cp.id}
									background={index === 0 ? '#366CFA' : '#00C952'}
									style={{ marginRight: 10 }}
									heightPercentage={percent}>
									<OverlayTrigger
										placement={
											index !== cancelamentos.length - 1 ? 'right' : 'left'
										}
										overlay={
											<Tooltip id='tool-tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{floatTotal}
												</span>
											</Tooltip>
										}>
										<div className='merchant_rank_intern' />
									</OverlayTrigger>
								</S.ConciliatorLine>
							);
						})}
					</div>
					<p style={{ color: '#000' }} className='merchant_rank_label'>
						{'Cancelamentos'}
					</p>
				</div>

				<div className='merchant_rank_container'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							//justifyContent: 'space-between',
							height: '100%',
							//background: "#FFF",
							width: '100%',
						}}>
						{chargebacks.map((cp, index) => {
							let floatTotal = parseFloat(cp.total || '0');

							const percent = (floatTotal * 100) / highestTotal();

							return (
								<S.ConciliatorLine
									key={cp.id}
									background={index === 0 ? '#366CFA' : '#00C952'}
									style={{ marginRight: 10 }}
									heightPercentage={percent}>
									<OverlayTrigger
										placement={
											index !== chargebacks.length - 1 ? 'right' : 'left'
										}
										overlay={
											<Tooltip id='tool-tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{floatTotal}
												</span>
											</Tooltip>
										}>
										<div className='merchant_rank_intern' />
									</OverlayTrigger>
								</S.ConciliatorLine>
							);
						})}
					</div>

					<p style={{ color: '#000' }} className='merchant_rank_label'>
						{'CHARGEBACKS'}
					</p>
				</div>

				<div className='merchant_rank_container'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							//justifyContent: 'space-between',
							height: '100%',
							//background: "#FFF",
							width: '100%',
						}}>
						{pagamentos.map((cp, index) => {
							let floatTotal = parseFloat(cp.total || '0');

							const percent = (floatTotal * 100) / highestTotal();

							return (
								<S.ConciliatorLine
									key={cp.id}
									background={index === 0 ? '#366CFA' : '#00C952'}
									style={{ marginRight: 10 }}
									heightPercentage={percent}>
									<OverlayTrigger
										placement={
											index !== pagamentos.length - 1 ? 'right' : 'left'
										}
										overlay={
											<Tooltip id='tool-tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{floatTotal}
												</span>
											</Tooltip>
										}>
										<div className='merchant_rank_intern' />
									</OverlayTrigger>
								</S.ConciliatorLine>
							);
						})}
					</div>

					<p style={{ color: '#000' }} className='merchant_rank_label'>
						{'Pagamentos'}
					</p>
				</div>

				{/*concTemp.map((ct, index) => {
					let highestMaq = 0;
					let floatMaq = 0;
					floatMaq = ct.maq;

					let highestApp = 0;
					let floatApp = 0;
					floatApp = ct.app;

					concTemp.forEach((c) => {
						if (c.maq > highestMaq) {
							highestMaq = c.maq;
						}
						if (c.app > highestApp) {
							highestApp = c.app;
						}
					});

					const percentApp = (floatApp * 100) / highestApp;
					const percentMaq = (floatMaq * 100) / highestMaq;

					return (
						<div key={ct.label} className='merchant_rank_container'>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									//justifyContent: 'space-between',
									height: '100%',
									//background: "#FFF",
									width: '100%',
								}}>
								<S.ConciliatorLine
									background='#366CFA'
									style={{ marginRight: 10 }}
									heightPercentage={percentMaq}>
									<OverlayTrigger
										placement={index !== concTemp.length - 1 ? 'right' : 'left'}
										overlay={
											<Tooltip id='tool-tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{floatMaq}
												</span>
											</Tooltip>
										}>
										<div className='merchant_rank_intern' />
									</OverlayTrigger>
								</S.ConciliatorLine>

								<S.ConciliatorLine
									background='#00C952'
									heightPercentage={percentApp}>
									<OverlayTrigger
										placement={index !== concTemp.length - 1 ? 'right' : 'left'}
										overlay={
											<Tooltip id='tool-tip'>
												<span style={{ textTransform: 'capitalize' }}>
													{floatApp}
												</span>
											</Tooltip>
										}>
										<div className='merchant_rank_intern' />
									</OverlayTrigger>
								</S.ConciliatorLine>
							</div>
							<p style={{ color: '#000' }} className='merchant_rank_label'>
								{ct.label}
							</p>
						</div>
					);
				})*/}
			</S.ConcRank>

			<div className='card_row card_align_center'>
				<div className='card_row card_align_center'>
					<S.LegendDot background='#366CFA' />
					<S.LegendLabel color='#222222'>Homologação</S.LegendLabel>
				</div>
				<div style={{ marginLeft: 7 }} className='card_row card_align_center'>
					<S.LegendDot background='#00C952' />
					<S.LegendLabel color='#222222'>Simulador</S.LegendLabel>
				</div>
			</div>
		</S.CardItem>
	);
}

function useOutsideAlert(ref: any, handleClickOutside: any) {
	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref]);
}
/*
function Marker(props: any) {
	return (
		<div
			style={{
				height: props.size,
				width: props.size,
				borderRadius: props.size / 2,
				background: props.color,
			}}>
			{
				//props.name
			}
		</div>
	);
}*/

function CardRowScroll({ porConta }: { porConta: DashConta[] }) {
	function calcPercentage(a: number, b: number) {
		return 100 * Math.abs((a - b) / ((a + b) / 2));
	}

	const cardRef = useRef<any>(null);
	const { onMouseDown } = useDraggableScroll(cardRef);

	return (
		<S.CardRowScroll onMouseDown={onMouseDown} ref={cardRef}>
			{porConta.map((item, index) => {
				return (
					<S.CardItemScroll>
						<S.CardMeasureTitle>{item.nome}</S.CardMeasureTitle>
						<S.GreenLine />
						<S.CardValue>{item.atual}</S.CardValue>

						<S.CardPercentageContainer>
							{
								<S.CardPercentage
									style={{
										opacity:
											calcPercentage(
												parseFloat(item.atual || '0'),
												parseFloat(item.comparado || '0')
											) !== 0
												? 1
												: 0,
									}}
									negative={
										parseFloat(item.atual || '0') -
											parseFloat(item.comparado || '0') <
										0
									}>
									<img
										src={TrendingUp}
										alt='up'
										className='TrendingUp'
										color='#4BAF50'
										//size='12'
										style={{ marginRight: 8 }}
									/>
									<img
										src={TrendingDown}
										alt='down'
										className='TrendingDown'
										color='#C90716'
										//size='12'
										style={{ marginRight: 8 }}
									/>
									{`${calcPercentage(
										parseFloat(item.atual || '0'),
										parseFloat(item.comparado || '0')
									).toLocaleString('pt-BR', {
										maximumFractionDigits: 2,
									})}%`}
								</S.CardPercentage>
							}
						</S.CardPercentageContainer>
					</S.CardItemScroll>
				);
			})}
		</S.CardRowScroll>
	);
}

function RowCardType({ porTipo }: { porTipo: DashPorTipo[] }) {
	const debito = porTipo.find((p) => p.tipo === '1');
	const credParc = porTipo.find((p) => p.tipo === '2' && p.parcelado);
	const credVista = porTipo.find((p) => p.tipo === '2' && !p.parcelado);

	/*function calcPercentage(a: number, b: number) {
		return 100 * Math.abs((a - b) / ((a + b) / 2));
	}
*/
	// a = 100% b = numero a testar
	function calcPercentageOf(a: number, b: number) {
		if (a === 0) return 0;
		return (100 * b) / a;
	}

	function calcTotal() {
		let t = 0;
		t =
			parseFloat(credVista?.atual || '0') +
			parseFloat(credParc?.atual || '0') +
			parseFloat(debito?.atual || '0');

		return t;
	}

	return (
		<S.RowCards
			className='mt-12'
			style={{ display: 'flex', flexDirection: 'row' }}>
			<S.CardWithoutFlex style={{ width: '34%' }}>
				<S.CardItem>
					<S.CardMeasureTitle>Débito</S.CardMeasureTitle>
					<S.GreenLine />
					<S.CardValue>
						<span>R$ </span>{' '}
						{debito
							? Math.abs(parseFloat(debito.atual || '0')).toLocaleString(
									'pt-BR',
									{
										maximumFractionDigits: 2,
										minimumFractionDigits: 2,
									}
							  )
							: '0,00'}
					</S.CardValue>
					<S.CardPercentageContainer
						style={{
							opacity: 1,
						}}>
						<S.CardPercentage defaultColor negative={false}>
							<img
								src={DataSaverGreen}
								alt='up'
								className='TrendingUp'
								color='#4BAF50'
								//size='12'
								style={{ marginRight: 8 }}
							/>
							<img
								src={DataSaverRed}
								alt='down'
								className='TrendingDown'
								color='#C90716'
								//size='12'
								style={{ marginRight: 8 }}
							/>
							{`${
								debito
									? `${calcPercentageOf(
											calcTotal(),
											parseFloat(debito.atual || '0')
									  ).toLocaleString('pt-BR', {
											maximumFractionDigits: 2,
									  })}`
									: `0`
							}% das transações`}
						</S.CardPercentage>
					</S.CardPercentageContainer>
				</S.CardItem>
			</S.CardWithoutFlex>
			<div
				className='ml-15'
				style={{
					display: 'flex',
					flexDirection: 'row',
					width: '66%',
				}}>
				<S.CardWithoutFlex style={{ flex: 1 }}>
					<S.CardItem>
						<S.CardMeasureTitle>Crédito a Vista</S.CardMeasureTitle>
						<S.GreenLine />
						<S.CardValue>
							<span>R$ </span>{' '}
							{credVista
								? Math.abs(parseFloat(credVista.atual || '0')).toLocaleString(
										'pt-BR',
										{
											maximumFractionDigits: 2,
											minimumFractionDigits: 2,
										}
								  )
								: '0,00'}
						</S.CardValue>
						<S.CardPercentageContainer
							style={{
								opacity: 1,
							}}>
							<S.CardPercentage defaultColor negative={false}>
								<img
									src={DataSaverGreen}
									alt='up'
									className='TrendingUp'
									color='#4BAF50'
									style={{ marginRight: 8 }}
									//size='12'
								/>
								<img
									src={DataSaverRed}
									alt='down'
									className='TrendingDown'
									color='#C90716'
									//size='12'
									style={{ marginRight: 8 }}
								/>
								{`${
									credVista
										? `${calcPercentageOf(
												calcTotal(),
												parseFloat(credVista.atual || '0')
										  ).toLocaleString('pt-BR', {
												maximumFractionDigits: 2,
										  })}`
										: `0`
								}% das transações`}{' '}
							</S.CardPercentage>
						</S.CardPercentageContainer>
					</S.CardItem>
				</S.CardWithoutFlex>
				<S.CardWithoutFlex style={{ flex: 1 }} className='ml-15'>
					<S.CardItem>
						<S.CardMeasureTitle>Crédito Parcelado</S.CardMeasureTitle>
						<S.GreenLine />
						<S.CardValue>
							<span>R$ </span>
							{credParc
								? Math.abs(parseFloat(credParc.atual || '0')).toLocaleString(
										'pt-BR',
										{
											maximumFractionDigits: 2,
											minimumFractionDigits: 2,
										}
								  )
								: '0,00'}
						</S.CardValue>
						<S.CardPercentageContainer
							style={{
								opacity: 1,
							}}>
							<S.CardPercentage defaultColor negative={false}>
								<img
									src={DataSaverGreen}
									alt='up'
									className='TrendingUp'
									color='#4BAF50'
									style={{ marginRight: 8 }}
									//size='12'
								/>
								<img
									src={DataSaverRed}
									alt='down'
									className='TrendingDown'
									color='#C90716'
									//size='12'
									style={{ marginRight: 8 }}
								/>
								{`${
									credParc
										? `${calcPercentageOf(
												calcTotal(),
												parseFloat(credParc.atual || '0')
										  ).toLocaleString('pt-BR', {
												maximumFractionDigits: 2,
										  })}`
										: `0`
								}% das transações`}{' '}
							</S.CardPercentage>
						</S.CardPercentageContainer>
					</S.CardItem>
				</S.CardWithoutFlex>
			</div>
		</S.RowCards>
	);
}

/**
 * 
 * 
 * <S.CardItem>
				<S.RowBetween>
					<S.Row>
						<S.CardTitle>Conciliações</S.CardTitle>
					</S.Row>
				</S.RowBetween>

				<S.ConcRank>
					{concTemp.map((ct, index) => {
						let highestMaq = 0;
						let floatMaq = 0;
						floatMaq = ct.maq;

						let highestApp = 0;
						let floatApp = 0;
						floatApp = ct.app;

						concTemp.forEach((c) => {
							if (c.maq > highestMaq) {
								highestMaq = c.maq;
							}
							if (c.app > highestApp) {
								highestApp = c.app;
							}
						});

						const percentApp = (floatApp * 100) / highestApp;
						const percentMaq = (floatMaq * 100) / highestMaq;

						return (
							<div key={ct.label} className='merchant_rank_container'>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										//justifyContent: 'space-between',
										height: '100%',
										//background: "#FFF",
										width: '100%',
									}}>
									<S.ConciliatorLine
										background='#366CFA'
										style={{ marginRight: 10 }}
										heightPercentage={percentMaq}>
										<OverlayTrigger
											placement={
												index !== concTemp.length - 1 ? 'right' : 'left'
											}
											overlay={
												<Tooltip id='tool-tip'>
													<span style={{ textTransform: 'capitalize' }}>
														{floatMaq}
													</span>
												</Tooltip>
											}>
											<div className='merchant_rank_intern' />
										</OverlayTrigger>
									</S.ConciliatorLine>

									<S.ConciliatorLine
										background='#00C952'
										heightPercentage={percentApp}>
										<OverlayTrigger
											placement={
												index !== concTemp.length - 1 ? 'right' : 'left'
											}
											overlay={
												<Tooltip id='tool-tip'>
													<span style={{ textTransform: 'capitalize' }}>
														{floatApp}
													</span>
												</Tooltip>
											}>
											<div className='merchant_rank_intern' />
										</OverlayTrigger>
									</S.ConciliatorLine>
								</div>
								<p style={{ color: '#000' }} className='merchant_rank_label'>
									{ct.label}
								</p>
							</div>
						);
					})}
				</S.ConcRank>

				<div className='card_row card_align_center'>
					<div className='card_row card_align_center'>
						<S.LegendDot background='#366CFA' />
						<S.LegendLabel color='#676767'>Maquininhas e TEFs</S.LegendLabel>
					</div>
					<div style={{ marginLeft: 7 }} className='card_row card_align_center'>
						<S.LegendDot background='#00C952' />
						<S.LegendLabel color='#676767'>Site e APP</S.LegendLabel>
					</div>
				</div>

				{/*
				<ListRank>
					{rankInfo.data.map((item) => {
						let maxV = 0;

						for (let i = 0; i < rankInfo.data.length; i++) {
							if (rankInfo.data[i].valor > maxV) {
								maxV = rankInfo.data[i].valor;
							}
						}
						let w = '0%';
						//////console.log(maxV);

						if (maxV === item.valor) {
							w = '100%';
						} else {
							let n = (item.valor * 100) / maxV;
							w = `${n}%`;
						}

						//////console.log(w);

						return (
							<div
								key={item.unidade}
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									marginBlock: 8,
								}}>
								<ListRankTextLight
									className='ranking-text-light'
									style={{ flex: 1.5 }}>
									{item.unidade}
								</ListRankTextLight>
								<div style={{ flex: 5 }}>
									<div
										style={{
											width: w,
											background: '#09AA36',
											height: 8,
											borderRadius: 5,
										}}
									/>
								</div>
								{
									<NumberFormat
										className='ranking-text-medium'
										value={item.valor}
										thousandSeparator='.'
										decimalSeparator=','
										decimalScale={2}
										fixedDecimalScale={true}
										prefix='R$ '
										displayType='text'
										//isAllowed={false}
										style={{
											flex: 2,
										}}></NumberFormat>
								}
							</div>
						);
					})}
				</ListRank>
}
</S.CardItem>
 * 
 * 
 */
